import React, { useEffect, useRef } from "react";
import style from "./home.module.scss";
import { TexhnextLogosYellow, Texhnextyellowbg } from "assets";
import { gsap } from "gsap/dist/gsap";
import { useNavigate } from "react-router-dom";

const HomeUI = () => {
  const navigate = useNavigate();
  let color1 = useRef(null);
  let color2 = useRef(null);
  let color3 = useRef(null);
  let color4 = useRef(null);
  let color5 = useRef(null);
  let color6 = useRef(null);
  let header = useRef(null);

  useEffect(() => {
    var tll = gsap.timeline();
    var tl = gsap.timeline({ repeat: -1 });

    tll.to(header, {
      y: 0,
      opacity: 1,
      duration: 1,
      ease: "power4",
    });

    tl.to(color1, {
      delay: 1,
      opacity: 0,
      duration: 1.5,
    })
      .to(color2, {
        opacity: 1,
        duration: 1.5,
      })
      .to(color2, {
        delay: 1,
        opacity: 0,
        duration: 1.5,
      })
      .to(color3, {
        opacity: 1,
        duration: 1.5,
      })
      .to(color3, {
        delay: 1,
        opacity: 0,
        duration: 1.5,
      })
      .to(color4, {
        opacity: 1,
        duration: 1.5,
      })
      .to(color4, {
        delay: 1,
        opacity: 0,
        duration: 1.5,
      })
      .to(color5, {
        opacity: 1,
        duration: 1.5,
      })
      .to(color5, {
        delay: 1,
        opacity: 0,
        duration: 1.5,
      })
      .to(color6, {
        opacity: 1,
        duration: 1.5,
      })
      .to(color6, {
        delay: 1,
        opacity: 0,
        duration: 1.5,
      });
  });

  return (
    <>
      <div className={style.container}>
        <div className={style.top}>
          <h1 ref={(el) => (header = el)}>
            CONNECTING THE FUTURE TO THE PRESENT
          </h1>
        </div>
        <div className={style.bottom}>
          <div className={style.hex_container}>
            <div
              transition={{ staggerChildren: 1 }}
              className={style.container}
            >
              <div className={`${style.hexagonArea} ${style.first}`}>
                <div role="button" className={`${style.hexagon} ${style.one}`}>
                  <div
                    ref={(el) => (color1 = el)}
                    onClick={() =>
                      navigate("/info", {
                        state: {
                          view: 0,
                        },
                      })
                    }
                    className={style.inner}
                  >
                    <h3>Innovation</h3>
                  </div>
                  <div
                    onClick={() =>
                      navigate("/info", {
                        state: {
                          view: 0,
                        },
                      })
                    }
                    className={style.overlay}
                  >
                    <h3>Innovation</h3>
                  </div>
                </div>
                <div role="button" className={`${style.hexagon} ${style.two}`}>
                  <div
                    ref={(el) => (color2 = el)}
                    onClick={() =>
                      navigate("/info", {
                        state: {
                          view: 1,
                        },
                      })
                    }
                    className={style.inner}
                  >
                    <h3>Ethics</h3>
                  </div>
                  <div
                    onClick={() =>
                      navigate("/info", {
                        state: {
                          view: 1,
                        },
                      })
                    }
                    className={style.overlay}
                  >
                    <h3>Ethics</h3>
                  </div>
                </div>
              </div>
              <div className={`${style.hexagonArea} ${style.second}`}>
                <div
                  role="button"
                  className={`${style.hexagon} ${style.three}`}
                >
                  <div
                    ref={(el) => (color6 = el)}
                    onClick={() =>
                      navigate("/info", {
                        state: {
                          view: 5,
                        },
                      })
                    }
                    className={style.inner}
                  >
                    <h3>Drive</h3>
                  </div>
                  <div
                    onClick={() =>
                      navigate("/info", {
                        state: {
                          view: 5,
                        },
                      })
                    }
                    className={style.overlay}
                  >
                    <h3>Drive</h3>
                  </div>
                </div>
                <div role="button" className={style.hexagon}>
                  <div className={`${style.inner} ${style.yellow}`}>
                    <img src={Texhnextyellowbg} alt="Technext" />
                  </div>
                </div>
                <div role="button" className={`${style.hexagon} ${style.four}`}>
                  <div
                    ref={(el) => (color3 = el)}
                    onClick={() =>
                      navigate("/info", {
                        state: {
                          view: 2,
                        },
                      })
                    }
                    className={style.inner}
                  >
                    <h3>Passion</h3>
                  </div>
                  <div
                    onClick={() =>
                      navigate("/info", {
                        state: {
                          view: 2,
                        },
                      })
                    }
                    className={style.overlay}
                  >
                    <h3>Passion</h3>
                  </div>
                </div>
              </div>
              <div className={`${style.hexagonArea} ${style.third}`}>
                <div role="button" className={`${style.hexagon} ${style.five}`}>
                  <div
                    ref={(el) => (color5 = el)}
                    onClick={() =>
                      navigate("/info", {
                        state: {
                          view: 4,
                        },
                      })
                    }
                    className={style.inner}
                  >
                    <h3>Grit</h3>
                  </div>
                  <div
                    onClick={() =>
                      navigate("/info", {
                        state: {
                          view: 4,
                        },
                      })
                    }
                    className={style.overlay}
                  >
                    <h3>Grit</h3>
                  </div>
                </div>
                <div role="button" className={`${style.hexagon} ${style.six}`}>
                  <div
                    ref={(el) => (color4 = el)}
                    onClick={() =>
                      navigate("/info", {
                        state: {
                          view: 3,
                        },
                      })
                    }
                    className={style.inner}
                  >
                    <h3>Intelligence</h3>
                  </div>
                  <div
                    onClick={() =>
                      navigate("/info", {
                        state: {
                          view: 3,
                        },
                      })
                    }
                    className={style.overlay}
                  >
                    <h3>Intelligence</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { HomeUI };
